/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserIgnorePopoverContainer_user = {
    readonly id: string;
    readonly username: string | null;
    readonly " $refType": "UserIgnorePopoverContainer_user";
};
export type UserIgnorePopoverContainer_user$data = UserIgnorePopoverContainer_user;
export type UserIgnorePopoverContainer_user$key = {
    readonly " $data"?: UserIgnorePopoverContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"UserIgnorePopoverContainer_user">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserIgnorePopoverContainer_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '0fd3131cd71cffc13be5161a30f96cca';
export default node;
